import React from "react";
import {GrClose} from "react-icons/gr";

const DocumentUploadModal = ({
                                 isOpen,
                                 creatingNewDoc,
                                 newDocName,
                                 setNewDocName,
                                 file,
                                 handleFileChange,
                                 comment,
                                 setComment,
                                 emailInfo,
                                 setEmailInfo,
                                 emailGroups,
                                 toggleEmailGroup,
                                 onSave,
                                 onCancel
                             }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-text bg-opacity-50">
            <div className="relative w-full max-w-lg bg-white p-6 rounded-lg shadow-lg mx-4">
                <GrClose
                    className="cursor-pointer absolute top-4 right-4"
                    size="22px"
                    onClick={onCancel}
                />

                <h2 className="text-xl font-bold mb-4">Dokument hochladen</h2>

                {creatingNewDoc && (
                    <div className="mb-4">
                        <label className="block font-medium mb-1 text-left">Dokumentenname</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            placeholder="Bitte einen Namen für das Dokument vergeben"
                            value={newDocName}
                            onChange={(e) => setNewDocName(e.target.value)}
                        />
                    </div>
                )}

                <div className="mb-4">
                    <label className="block font-medium mb-1 text-left">Datei(en) auswählen</label>
                    <input
                        type="file"
                        multiple
                        className="w-full border rounded p-2"
                        onChange={handleFileChange}
                    />
                    {file && (
                        <div className="text-sm mt-1 text-gray-600 text-left">
                            {Array.isArray(file) ? (
                                file.length > 1 ? (
                                    <div>
                                        <p className="font-medium">{file.length} Dateien ausgewählt (werden automatisch als ZIP-Archiv hochgeladen):</p>
                                        <ul className="list-disc list-inside mt-1">
                                            {file.map((f, index) => (
                                                <li key={index}>{f.name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : (
                                    <p>{file[0].name}</p>
                                )
                            ) : (
                                <p>{file.name}</p>
                            )}
                        </div>
                    )}
                </div>

                <div className="mb-4">
                    <label className="block font-medium mb-1 text-left">Zusätzlicher Kommentar</label>
                    <textarea
                        className="w-full border rounded p-2"
                        placeholder="Zusätzlichen Kommentar hinzufügen"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>

                <div className="mb-2 text-red-600 font-medium text-left">per E-Mail Info an:</div>

                <div className="mb-4">
                    <label className="block font-medium mb-1 text-left sr-only">E-Mailadresse</label>
                    <input
                        type="email"
                        placeholder="[individuelle E-Mailadresse]"
                        className="w-full border border-red-500 p-2 rounded"
                        value={emailInfo}
                        onChange={(e) => setEmailInfo(e.target.value)}
                    />
                </div>

                <div className="flex flex-col gap-2 text-red-600 mb-6">
                    {["DGAPI-KAM", "DGAPI-AMS", "DG-Vertriebsmanagement"].map((group) => (
                        <label key={group} className="flex items-center gap-2 text-left">
                            <input
                                type="checkbox"
                                checked={emailGroups.includes(group)}
                                onChange={() => toggleEmailGroup(group)}
                            />
                            {group}
                        </label>
                    ))}
                </div>

                <div className="flex gap-4">
                    <button
                        onClick={onSave}
                        className="w-1/2 py-2 px-4 rounded text-white bg-mainBlue hover:bg-blue-600"
                    >
                        Speichern
                    </button>
                    <button
                        onClick={onCancel}
                        className="w-1/2 py-2 px-4 rounded text-white bg-cancel hover:bg-red-600"
                    >
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DocumentUploadModal;
